import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CorporateAppointmentDashboardComponent } from './corporate-appointment-dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: CorporateAppointmentDashboardComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CorporateAppointmentDashboardRoutingModule { }
